import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HabitacionService } from '@core/service/habitacion.service';
import { PaisService } from '@core/service/pais.service';
import { DepartamentoService } from '@core/service/departamento.service';
import { OcupaionesService } from '@core/service/ocupaiones.service';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  switchMap,
  take
} from 'rxjs/operators';
import { ClienteService } from '@core/service/cliente.service';
import { Departamento } from '@core/model/departamento.model';
import moment from 'moment';

@Component({
  selector: 'app-client-forms',
  templateUrl: './client-forms.component.html',
  styles: []
})
export class ClientFormsComponent implements OnInit, OnDestroy {
  formGroup: FormGroup;
  @Input() id: string;
  @Output() formReady = new EventEmitter<any>();
  paises: any[] = [];
  departamentos: any[] = [];
  ocupaciones: any[] = [];
  diffYears: number;

  constructor(
    private formBuilder: FormBuilder,
    public paisService: PaisService,
    public departamentoService: DepartamentoService,
    public ocupaionesService: OcupaionesService,
    public clienteService: ClienteService
  ) {
    this.formGroup = this.formBuilder.group({
      nombres: [
        '',
        [Validators.required, Validators.pattern('[0-9a-zA-ZñÑáéíóúÁÉÍÓÚx ]*')]
      ],
      apellidos: [
        '',
        [Validators.required, Validators.pattern('[0-9a-zA-ZñÑáéíóúÁÉÍÓÚx ]*')]
      ],
      ci: [
        '',
        [
          // Validators.pattern('[0-9a-zA-ZñÑáéíóúÁÉÍÓÚ[\\s-] ]*'),
          Validators.required,
          Validators.pattern('[0-9a-zA-ZñÑáéíóúÁÉÍÓÚ_.+-]*'),
          Validators.minLength(6)
        ]
      ],
      pais: [
        'BOLIVIA',
        [Validators.required, Validators.pattern('[0-9a-zA-ZñÑáéíóúÁÉÍÓÚx ]*')]
      ],
      departamento_id: [
        '',
        [Validators.required, Validators.pattern('[0-9a-zA-ZñÑáéíóúÁÉÍÓÚx ]*')]
      ],
      ocupacion: [
        '',
        [Validators.required, Validators.pattern('[0-9a-zA-ZñÑáéíóúÁÉÍÓÚx ]*')]
      ],
      celular: ['', [Validators.pattern('[0-9a-zA-ZñÑáéíóúÁÉÍÓÚx ]*')]],
      fecha_nac: ['', Validators.required],
      cliente_id: '',
      estado_civil: ''
    });
  }

  ngOnInit(): void {
    this.formReady.emit({ name: 'cliente', form: this.formGroup });
    // todo mejorar las peticiones
    this.paisService.getAll().subscribe(res => {
      this.paises = res.data;
      this.formGroup.patchValue({ pais: res.data[0].nombre });
      console.log('paises', res.data);
    });
    this.departamentoService
      .getAll()
      .pipe(take(1))
      .subscribe((res: Departamento[]) => {
        this.departamentos = res;
        this.formGroup.patchValue({
          departamento_id: res[0].departamento_id
        });
        // console.log(this.departamentos);
      });
    this.ocupaionesService
      .getEnabledList()
      .pipe(take(1))
      .subscribe(res => {
        this.ocupaciones = res;
        this.formGroup.patchValue({ ocupacion: res[0].nombre });
        // console.log(res);
      });

    this.formGroup
      .get('ci')
      .valueChanges.pipe(
        map(e => {
          console.log(e);
          return e;
        }),
        filter<string>(ci => ci.length > 2),
        debounceTime(550),
        distinctUntilChanged(),
        switchMap(ci => this.clienteService.getByCI(ci))
      )
      .subscribe(cliente => {
        // console.log('cliente', cliente);
        if (Object.entries(cliente).length !== 0) {
          const fecha = moment(cliente.fecha_nac);
          this.formGroup.patchValue({
            nombres: cliente.nombres,
            apellidos: cliente.apellidos,
            ci: cliente.ci,
            departamento_id: cliente.departamento_id,
            pais: cliente.pais.nombre,
            ocupacion: cliente.ocupacion.nombre,
            cliente_id: cliente.cliente_id,
            celular: cliente.celular,
            fecha_nac: fecha.format('YYYY-MM-DD')
          });
        } else {
          this.formGroup.patchValue({
            // nombres: '',
            // apellidos: '',
            // ci: this.formGroup.get('ci').value,
            // departamento_id: '',
            // pais: '',
            // celular: '',
            // ocupacion_id: '',
            // cliente_id: null
            nombres: this.formGroup.get('nombres').value,
            apellidos: this.formGroup.get('apellidos').value,
            ci: this.formGroup.get('ci').value,
            departamento_id: this.formGroup.get('departamento_id').value,
            pais: this.formGroup.get('pais').value,
            celular: this.formGroup.get('celular').value,
            fecha_nac: this.formGroup.get('fecha_nac').value,
            ocupacion: this.formGroup.get('ocupacion').value,
            cliente_id: null
          });
        }
      });
  }

  ngOnDestroy(): void {
    this.formReady.unsubscribe();
  }

  onValueChange(event?: any) {
    // console.log(event);
    this.formReady.emit({ name: 'cliente', form: this.formGroup });
  }

  calculateAge(target: any) {
    const dateNow = moment();
    const dateBirth = moment(target.value);

    this.diffYears = dateNow.diff(dateBirth, 'years');
  }
}
